/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
// import {Editor} from '@tinymce/tinymce-react'

import Editor from 'src/app/components/Editor'

import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {create, deleteFile, getFile} from '../../../api/modules/file'
import {getPlant2} from '../../../api/modules/getdatalist'
import {editChildPlant} from '../../../api/modules/order'
import {createSIP, getAccesses, getPOApproved, getPOforSIP} from '../../../api/modules/sip'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {PopoverText} from '../../../components/Popover/Popover'
import AddRemoveJadwal from './AddRemoveJadwal'
import CustomUseEffect from './CustomUseEffect'
import {TableBrowseApprovedOrders} from './TableBrowseApprovedOrders'
import {fetchPOApproved, headers} from '../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {resetFilterPOApproved, sipSelector} from '../../../redux/slices/sipSlices'
import {objToParams} from '../../../utils/objToParams'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses, UserSegment} from 'src/components/mikro/getHakAkses'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FindTodayDate_DDMMYY} from 'src/components/mikro/FindTodayDate_DDMMYY'
import Skeleton from 'react-loading-skeleton'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import {getForModule} from 'src/api/modules/configuration/signing'
import { getLetterForModule } from 'src/api/modules/letterconfig'
import { InputFile } from 'src/app/components/InputFile'
import { base64ToBlob, handleDownloadAttachment, handleDownloadBase64 } from 'src/app/helpers/file'
import { SettingApproval } from './SettingApproval'

const SICreate: React.FC = () => {
  const intl = useIntl()
  const editorRef: any = useRef()
  const {roleId} = useAppSelector(authSelector)
  const {filterPOApproved} = useAppSelector(sipSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [showLetter, setShowLetter] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)

  const [findocState, setFindocState] = useState(false)
  const [findoc, setFindoc] = useState('')
  const [prinout, setPrintout] = useState('')
  const [printoutState, setPrinoutState] = useState(false)
  const [userState, setUserState] = useState('Admin')
  // const [approvalState, setApprovalState] = useState(false)
  const handleClose1 = () => setShow1(false)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => {
    setSearchpo('')
    setSearchname('')
    setSearchSektor('')
    setShow4(true)
    dispatch(resetFilterPOApproved())
  }

  const handleFindoc = () => {
    if (findoc == 'Findoc') setFindocState(true)
    else setFindocState(false)
  }
  const handlePrinout = () => {
    if (prinout == 'Printout CO') setPrinoutState(true)
    else setPrinoutState(false)
  }

  let changes = 0

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [showApprove, setShowApprove] = useState(false)

  const navigate = useNavigate()

  //#region
  const [fullPO, setFullPO] = useState<any[]>([])
  const [orderSelect, setOrderSelect] = useState<any[]>([])
  const [orderPelanggan, setOrderPelanggan] = useState('')
  const [orderPelangganValue, setOrderPelangganValue] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [perihal, setPerihal] = useState('')
  const [perihalTanggal, setPerihalTanggal] = useState('')
  const [addedOrder, setAddedOrder] = useState<any[]>([])
  const [indexOrder, setIndexOrder] = useState<any[]>([])
  const [isAdded, setIsAdded] = useState(false)
  const [totalPrice, setTotalPrice] = useState(0)
  const [totalQuantum, setTotalQuantum] = useState(0)
  const [plant, setPlant] = useState('')
  const [plantDesc, setPlantDesc] = useState('')
  const [idPengajuan, setIDPengajuan] = useState('')
  const [subID, setSubID] = useState([])
  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [dist, setDist] = useState('')
  const [sales, setSales] = useState('')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [matNumber, setMatNumber] = useState('')
  const [grandtotal, setGrandtotal] = useState(0)
  const [grandtotalUsd, setGrandtotalUsd] = useState(0)
  const [fullID, setFullID] = useState<any[]>([])
  const [showDetail, setShowDetail] = useState(false)
  const [custAccount, setCustAccount] = useState('')
  const [lain, setLain] = useState<any>('')
  const [initialFooterContent, setInitialFooterContent] = useState(
    '<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>'
  )
  const [initialBodyContent, setInitialBodyContent] = useState(
    '<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>'
  )
  const [footerContent, setFooterContent] = useState<any>('')
  const [bodyContent, setBodyContent] = useState<any>('')
  const [sektorID, setSektorID] = useState('')
  const [detailOrder, setDetailOrder] = useState<any>({})
  const [retailFlag, setRetailFlag] = useState('')
  const [kepada, setKepada] = useState('')
  const [signername, setSignerName] = useState('')
  const [singerposition, setSignerPositon] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  //#endregion

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [selectedIndex, setSelectedIndex] = useState<any>([])
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [param, setParam] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [accesses, setAccesses] = useState<any>()
  const [isFetchingPOApproved, setIsFetchingPOApproved] = useState(false)
  const [fileBox, setFileBox] = useState<any>({})
  const [configLetter, setConfigLetter] = useState<any>(null)

  const [approvers, setApprovers] = useState<any[]>([])
  const [reviewers, setReviewers] = useState<any[]>([])

  const onChangeApprovers = (data: any[]) => {
    setApprovers(data)
  }
  const onChangeReviewers = (data: any[]) => {
    setReviewers(data)
  }

  const signingModulePayload = {
    module: 'SIP',
    sector_id: null,
    total_quantum: 0
  }

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }
  // console.log(indexOrder, 'index order')

  const ambilAttachment = async (id: any, type: any = null) => {
    setIsLoadingModal(true)
    
    if(type) setParam(type)
    await getFile(type || param, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setIsLoadingModal(false)
    })
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate1') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create(param, formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setIsPrivate(false)
          setFiles({file: null})
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [previewSector, setPreviewSector] = useState("")

  const getOrder = async (e: any) => {
    setIsAdded(true)
    setAddedOrder([])
    setIndexOrder([])
    setSelectedIndex([])
    setPerihalTanggal('')
    setDateFrom('')
    setDateTo('')
    const date = document.getElementById('inputdate') as HTMLInputElement
    if (date != null) date.value = ''
    const date2 = document.getElementById('inputdate2') as HTMLInputElement
    if (date2 != null) date2.value = ''
    const date3 = document.getElementById('inputdate3') as HTMLInputElement
    if (date3 != null) date3.value = ''
    setIDPengajuan(e)

    if (e !== null) {
      handleClose4()
    }

    const res = await getPOforSIP(e, localStorage.getItem('credential')!)

    if (!res.data.error) {
      let tempArray: any[] = []
      res.data.data.children.forEach((item: any) => {
        if(item?.sector){
          setPreviewSector(item?.sector?.name)
        }
        tempArray.push(item.id)
      })

      setInitialBodyContent(
        `<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan ${
          res.data.data.customer?.title
            ? res.data.data.customer?.title + ' ' + res.data.data.customer?.name
            : res.data.data.customer?.name
        } melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>`
      )

      setFooterContent(configLetter?.indonesia?.footer ??
        '<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>'
      )
      setLain(configLetter?.indonesia?.other ??
        '<ol><li>Produk tersebut adalah produk Non Subsidi.</li><li>Nilai PPN menyesuaikan dengan peraturan pemerintah yang berlaku pada saat pengambilan.</li><li>Ketentuan dalam dokumen jual beli minimal harus merujuk pada Surat Informasi Penjualan.</li><li>Ketentuan dalam dokumen jual beli tidak boleh merugikan posisi PT Pupuk Indonesia (Persero) Group serta harus sesuai dengan ketentuan serta peraturan perundang-undangan yang berlaku serta prinsip-prinsip Good Corporate Governance.</li><li>Apabila terdapat kendala/hal yang ingin diklarifikasi terkait penerbitan SIP, mohon dikomunikasikan kepada PT Pupuk Indonesia (Persero) dalam kurun waktu 60 Menit setelah tanggal penerbitan SIP. Di luar batas tersebut, SIP dianggap disetujui dan dapat diimplementasikan sebaik mungkin.</li><li>Ketentuan lebih lanjut sehubungan dengan pelaksanaan Surat Informasi Penjualan ini sebagaimana terlampir.</li></ol>'
      )
      setBodyContent(configLetter?.indonesia?.content ??
        `<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan ${
          res.data.data.customer?.title
            ? res.data.data.customer?.title + ' ' + res.data.data.customer?.name
            : res.data.data.customer?.name
        } melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>`
      )

      setFullID(tempArray)
      setOrderSelect(res.data.data.children)
      setCustAccount(res.data.data.customer?.customer_account_group)
      setOrderPelanggan(
        res.data.data.customer?.title
          ? res.data.data.customer?.title + ' ' + res.data.data.customer?.name
          : res.data.data.customer?.name
      )
      setOrderPelangganValue(res.data.data.customer_id)
      setPerihal(res.data.data.regarding)
      setDist(res.data.data.distribution_channel)
      setSektorID(res.data.data.sector_id)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerTitle(res.data.data.customer?.title)
      setCustomerAddress(res.data.data.customer?.address)
      // setApprovalState(res.data.data.customer?.customer_account_group)

      signingModulePayload.sector_id = res.data.data?.sector_id
      signingModulePayload.total_quantum = res.data.data?.total_fixed_quantum
      loadSigningConfig()
    }
    setIsAdded(false)
  }

  const onclickCheckBox = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
    const tempArray: any[] = indexOrder
    let temp = parseInt(isChecked.value)
    if (isChecked.checked) {
      tempArray.push(temp)
    } else {
      const tempindex = tempArray.indexOf(temp)
      tempArray.splice(tempindex, 1)
    }
    setIndexOrder(tempArray)
  }

  const addInOrder = (type: any) => {
    const tempArray: any[] = []
    const tempindex: any[] = []
    let tempPrice = 0
    let tempQuantum = 0
    let grandtot = 0
    let grandtotusd = 0
    if (type == 'all') {
      fullID.forEach((value: any, index: any) => {
        tempArray.push(orderSelect[index])
        tempindex.push(parseFloat(index))
        tempPrice = tempPrice + parseFloat(orderSelect[index]?.fixed_price)
        tempQuantum = tempQuantum + parseFloat(orderSelect[index]?.fixed_quantum)
        grandtot =
          grandtot +
          parseFloat(orderSelect[index]?.fixed_price) *
            parseFloat(orderSelect[index]?.fixed_quantum)
        grandtotusd =
          grandtotusd +
          parseFloat(orderSelect[index]?.price_usd) *
            parseFloat(orderSelect[index]?.fixed_quantum)
      })
    } else {
      if (indexOrder.length < 1) {
        swal({
          title: `${t('item tidak boleh kosong')}`,
          icon: 'error',
        })
        return
      } else {
        indexOrder.forEach((value: any, index: any) => {
          tempArray.push(orderSelect[value])
          tempindex.push(value)
          tempPrice = tempPrice + parseFloat(orderSelect[index]?.fixed_price)
          tempQuantum = tempQuantum + parseFloat(orderSelect[index]?.fixed_quantum)
          grandtot =
            grandtot +
            parseFloat(orderSelect[index]?.fixed_price) *
              parseFloat(orderSelect[index]?.fixed_quantum)
          grandtotusd =
            grandtotusd +
            parseFloat(orderSelect[index]?.price_usd) *
              parseFloat(orderSelect[index]?.fixed_quantum)
        })
        // setIsAdded(true)
      }
    }
    // setInitialFooterContent(
    //   `<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar ${tempArray[0]?.produsen?.name} dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>`
    // )
    // setFooterContent(
    //   `<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar ${tempArray[0]?.produsen?.name} dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>`
    // )

    setIndexOrder([])
    setSelectedIndex(tempindex)
    setAddedOrder(tempArray)
    setShow2(false)
    setTotalPrice(tempPrice)
    setTotalQuantum(tempQuantum)
    setGrandtotal(grandtot)
    setGrandtotalUsd(grandtotusd)
    // console.log(addedOrder, ' addedOrder', tempPrice, ' tempprice ', tempQuantum, ' tempquantum')
    signingModulePayload.total_quantum = tempQuantum
    loadSigningConfig()
  }

  CustomUseEffect(() => {
    let tempPrice = 0
    let tempQuantum = 0
    let grandtot = 0
    let grandtotusd = 0
    addedOrder.forEach((value) => {
      tempPrice = tempPrice + parseFloat(value.fixed_price)
      tempQuantum = tempQuantum + parseFloat(value.fixed_quantum)
      grandtot = grandtot + parseFloat(value.fixed_price) * parseFloat(value.fixed_quantum)
      grandtotusd = grandtotusd + parseFloat(value.price_usd) * parseFloat(value.fixed_quantum)
    })
    setTotalPrice(tempPrice)
    setTotalQuantum(tempQuantum)
    setGrandtotal(grandtot)
    setGrandtotalUsd(grandtotusd)
    if (addedOrder.length < 1) {
      // setIDPengajuan('')
      setPerihal('')
      setCustomerCode('')
      setCustomerName('')
      setCustomerAddress('')
      setPerihalTanggal('')
      setDateFrom('')
      setDateTo('')
      // setSignerName('')
      // setSignerPositon('')
      setKepada('')
      setPaymentMethod('')
      setOrderSelect([])
      const date = document.getElementById('inputdate') as HTMLInputElement
      if (date != null) date.value = ''
      const date2 = document.getElementById('inputdate2') as HTMLInputElement
      if (date2 != null) date2.value = ''
      const date3 = document.getElementById('inputdate3') as HTMLInputElement
      if (date3 != null) date3.value = ''
      const assname = document.getElementById('assname') as HTMLInputElement
      if (assname != null) assname.value = ''
      const kep = document.getElementById('kepada') as HTMLInputElement
      if (kep != null) kep.value = ''
      const asspos = document.getElementById('asspos') as HTMLInputElement
      if (asspos != null) asspos.value = ''
      const metodepembayaran = document.getElementById('metodepembayaran') as HTMLInputElement
      if (metodepembayaran != null) metodepembayaran.value = ''
    }
    setInitialFooterContent(
      '<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>'
    )
    setInitialBodyContent(
      '<p>Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia (Persero) dengan melalui surat ini kami informasikan poin-poin pokok hasil kesepakatan sebagai berikut:</p>'
    )
  }, [addedOrder])

  const lang = i18next.language
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')

  const submitSIP = async () => {
    setBtnLoading(true)
    const tempfiles: any[] = []
    attachment?.forEach((data: any, _index: any) => {
      tempfiles.push(data)
      if (tempfiles?.length > -1) {
        const temp = data?.file_r.split(',')
        if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
      }
    })
    const tempid: string[] = []
    addedOrder.forEach((id) => {
      tempid.push(id.id)
    })
    const res = await createSIP(localStorage.getItem('credential'), {
      id_pengajuan_order: idPengajuan,
      customer: orderPelangganValue,
      perihal: perihal,
      estimate_date: perihalTanggal,
      valid_date_from: dateFrom,
      valid_date_to: dateTo,
      order_sub_detail_id: tempid,
      lang: lang,
      attachments: tempfiles,
      lain_lain: lain,
      kepada: kepada,
      signer_name: signername,
      signer_position: singerposition,
      payment_method_info: paymentMethod,
      body_content: bodyContent,
      footer_content: footerContent,
      reviewer_ids: reviewers.map((item: any) => item.value),
      approver_ids: approvers.map((item: any) => item.value)
    })
      .then((res: any) => {
        swal({
          title: `${t('SIP Created Successfully')}`,
          icon: 'success',
        }).then(() => {
          navigate('/management/si/all')
          setBtnLoading(false)
        })
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temp: any = [...addedOrder]
        const temp2: any = [...selectedIndex]
        // const temp3: any = [...orderSelect]
        temp.splice(index, 1)
        temp2.splice(index, 1)
        // temp3.splice(index, 1)
        setAddedOrder(temp)
        setSelectedIndex(temp2)

        let tempTotalQuantum = 0
        temp.forEach((item: any) => {
          tempTotalQuantum += item.fixed_quantum
        })

        // setOrderSelect(temp3)
        if (temp.length < 1) {
          setIDPengajuan('')
          // setSignerName('')
          // setSignerPositon('')
        }else{
          signingModulePayload.total_quantum = tempTotalQuantum
          loadSigningConfig()
        }
        swal({
          title: `${t('deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  useEffect(() => {
    const getSO = async () => {
      await getPOApproved(localStorage.getItem('credential')).then((res) => {
        setFullPO(res.data.data.data)
      })
    }

    const getLetterConfig = async () => {
      await getLetterForModule({
        sales_org: '',
        module: 'sip'
      }).then((res) => {
        setConfigLetter(res.data.data)
      })
    }

    getSO()
    getLetterConfig()

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }
    getAllRoleList()
    getAccessMenu()
  }, [])

  const separator = (value: any, left: any, right: any) => {
    const temp = value.split('~#~')
    left(temp[0])
    right(temp[1])
  }

  CustomUseEffect(() => {
    const plantData = async () => {
      await getPlant2(sales, dist, matNumber).then((res) => {
        setFullPlant(res.data.data)
      })
    }

    plantData()
  }, [sales])

  const [attachment, setAttachment] = useState<any[]>([])
  const [files2, setFiles2] = useState<any>()
  const [datenow, setDateNow] = useState('')
  const [showUpload2, setShowUpload2] = useState(false)

  const handleUploadHeader = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files2,
        name: namaFile,
        description: description,
        file_type: dataType,
        private: isPrivate.toString(),
        roles: temparray,
      }
      let tempArray = [...attachment]
      tempArray.push(tempObject)
      setAttachment(tempArray)
      // setShow1(false)
      removeFileState()
      clearInputUpload()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate1 = document.getElementById('isPrivate1') as HTMLInputElement
    if (inputPrivate1 != null) inputPrivate1.checked = false

    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false
  }

  const validasiFile = () => {
    if (files2 == null || files2 == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const removeFileState = () => {
    setFiles2('')
    setNamaFile('')
    setDescription('')
    setIsPrivate(false)
    setTempRole([])
    setDataType('')
  }
  
  const handleDeleteUploadHeader = (index: any, data: any, setData: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then((willDelete: any) => {
        if (willDelete) {
          const tempArray = [...data]
          tempArray.splice(index, 1)
          setData(tempArray)
          swal({
            closeOnClickOutside: false,
            title: t('Dokumen Berhasil Dihapus'),
            icon: 'success',
          })
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [numberURL, setNumberURL] = useState([])

  const paginateNumber = async (url: string) => {
    setIsFetchingPOApproved(true)

    const credentials = localStorage.getItem('credential')
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filterPOApproved)}`
    const token = localStorage.getItem('token') as string
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setFullPO(res.data.data.data)
    setNumberURL(res.data.data.links)
    setIsFetchingPOApproved(false)
  }

  //#region state for search
  const [searchpo, setSearchpo] = useState('')
  const [searchname, setSearchname] = useState('')
  const [searchsektor, setSearchSektor] = useState('')

  const onFetchPOApproved = useCallback(() => {
    setIsFetchingPOApproved(true)
    fetchPOApproved(filterPOApproved).then((res: any) => {
      setFullPO(res.data.data.data)
      setNumberURL(res.data.data.links)
      setIsFetchingPOApproved(false)
    })
  }, [filterPOApproved])

  useEffect(() => {
    const getData = setTimeout(() => onFetchPOApproved(), 1000)
    return () => clearTimeout(getData)
  }, [onFetchPOApproved])
  //#endregion

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  // console.log(idPengajuan)
  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const [previewSegment, setPreviewSegment] = useState<any[]>([])

  const LetterData = {
    kepada: kepada,
    produsen: addedOrder[0]?.produsen?.name,
    customer: customerTitle ? customerTitle + ' ' + customerName : customerName,
    subItem: addedOrder,
    dateFrom: dateFrom,
    dateTo: dateTo,
    includePpn: addedOrder[0]?.include_ppn,
    paymentInfo: paymentMethod,
    paymentMethod: addedOrder,
    lainlain: lain,
    signername: signername,
    singerposition: singerposition,
    sector: sektorID,
    tanggalApprove: FindTodayDate_DDMMYY(''),
    noSIP: '',
    tipePembayaranSIP: paymentMethod ? paymentMethod : '',
    footerContent: footerContent ? footerContent : '',
    bodyContent: bodyContent ? bodyContent : '',
    sectorName: previewSector,
    segments: previewSegment
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const loadSigningConfig = async () => {
    // setSignerName('')
    // setSignerPositon('')
    setBtnLoading(true)

    const res = await getForModule({
        ...signingModulePayload,
        sector_id: sektorID
      })
      .then((res: any) => {
        const resp = res.data.data
        if (resp) {
          if(!signername){
            setSignerName(resp.signer_name)
          }
          if(!singerposition){
            setSignerPositon(resp.signer_position)
          }
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  useEffect(() => {
    setPreviewSegment([]);
    let _segments: any[] = [];
    addedOrder.forEach((item: any) => {
      if(item.segment_name && !_segments.includes(item.segment_name)){
        _segments.push(item.segment_name)
      }
    })
    setPreviewSegment(_segments);
  }, [addedOrder])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page create sip')}</PageTitle>
      <div className='card'>
        {/* begin::Header */}
        <div className='card-body'>
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('order-no')}</p>
                </Col>
                <Col md={7}>
                  <div className='d-flex w-100'>
                    <Form.Control
                      type='text'
                      className='me-1'
                      disabled
                      value={idPengajuan}
                      placeholder={t('order-no')}
                      size='sm'
                    />
                    <Button
                      className='btn btn-primary d-flex justify-content-center align-items-center'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Browse')}
                      disabled={isAdded}
                      onClick={handleShow4}
                    >
                      <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                    </Button>
                    <Modal
                      show={show4}
                      onHide={handleClose4}
                      centered
                      backdrop='static'
                      keyboard={false}
                      size='lg'
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t('Browse')}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {isLoadingModal ? (
                          <Skeleton width={100} height={30} />
                        ) : (
                          <TableBrowseApprovedOrders
                            isLoading={isFetchingPOApproved}
                            orderList={fullPO}
                            selectedOrderId={idPengajuan}
                            paginateNumber={paginateNumber}
                            numberUrls={numberURL}
                            onSelectedOrder={(order) => {
                              getOrder(order.id)
                              setShow4(false)
                            }}
                          />
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                  {/* <Form.Select
                          aria-label='Default select example'
                          size='sm'
                          onChange={(e: any) => getOrder(e.target.value)}
                        >
                          <option selected hidden disabled>
                            {t('pilih')} SIP
                          </option>
                          {fullPO.map((item: any) => {
                            return <option value={item.id}>{item.po_number}</option>
                          })}
                        </Form.Select> */}
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerName}
                    placeholder={t('Customer Name')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Assigner Name')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    size='sm'
                    id='assname'
                    value={signername}
                    placeholder={t('Assigner Name')}
                    onChange={(e: any) => setSignerName(e.target.value)}
                    disabled={isAdded}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Start-Date')}
                    <span className='text-danger' hidden={sektorID != '2' ? false : true}>
                      *
                    </span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='date'
                    id='inputdate2'
                    key={changes}
                    aria-label='Default select example'
                    size='sm'
                    disabled={isAdded}
                    onChange={(e: any) => {
                      setDateFrom(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Tanggal Pengajuan SIP')} <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='date'
                    id='inputdate'
                    key={changes}
                    aria-label='Default select example'
                    size='sm'
                    disabled={isAdded}
                    onChange={(e: any) => {
                      setPerihalTanggal(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('kepada')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    size='sm'
                    id='kepada'
                    placeholder={t('kepada')}
                    disabled={isAdded}
                    onChange={(e: any) => setKepada(e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerCode}
                    placeholder={t('Customer Number')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    value={customerAddress}
                    placeholder={t('Address')}
                    disabled
                    style={{height: '40px'}}
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('Assigner Position')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id='asspos'
                    size='sm'
                    placeholder={t('Assigner Position')}
                    value={singerposition}
                    disabled={isAdded}
                    onChange={(e: any) => setSignerPositon(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>
                    {t('End-Date')}
                    <span className='text-danger' hidden={sektorID != '2' ? false : true}>
                      *
                    </span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='date'
                    id='inputdate3'
                    key={changes}
                    aria-label='Default select example'
                    size='sm'
                    disabled={isAdded}
                    onChange={(e: any) => {
                      setDateTo(e.target.value)
                      // console.log(perihalTanggal)
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Metode Pembayaran')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    id='metodepembayaran'
                    style={{height: '40px'}}
                    disabled={isAdded}
                    placeholder={t('Metode Pembayaran')}
                    onChange={(e: any) => setPaymentMethod(e.target.value)}
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('order-perihal')} </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    key={perihal}
                    placeholder={t('order-perihal')}
                    aria-label='Default select example'
                    size='sm'
                    value={
                      perihal == 'PO002'
                        ? t('Non-penjualan')
                        : perihal == 'PO001'
                        ? t('penjualan')
                        : ''
                    }
                    disabled
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Body</p>
            <Editor
                disabled={isAdded}
                data={bodyContent}
                onChange={ ( content ) => {
                    setBodyContent(content)
                }}
              />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>{t('Lain-lain')}</p>
            <Editor
              disabled={isAdded}
              data={lain}
              onChange={ ( content ) => {
                  setLain(content)
              }}
            />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Footer</p>
            <Editor
              disabled={isAdded}  
              data={footerContent}
              onChange={ ( content ) => {
                  setFooterContent(content)
              }}
            />
          </Form.Group>

          <hr />

          <div className='card-toolbar mt-10 d-flex'>
            {selectedIndex.length != orderSelect.length && (
              <Button
                onClick={() => {
                  handleShow2()
                }}
                disabled={isAdded}
                className='btn btn-primary fw-semibold d-flex align-items-center me-4'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('kontrak-tambah') + ' Item'}
                // data-bs-toggle='modal'
                // data-bs-target='#kt_modal_invite_friends'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah')} Item</p>
              </Button>
            )}
            {idPengajuan != '' && (
              <>
                <Button
                  onClick={() => {
                    setShowUpload2(true)
                  }}
                  className='btn btn-primary fw-semibold d-flex align-items-center me-4'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('order-lampiran')}
                >
                  <p>{t('order-lampiran')}</p>
                </Button>

                <Button
                  onClick={() => {
                    setShowLetter(true)
                  }}
                  className='btn btn-primary fw-semibold d-flex align-items-center'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('preview')}
                >
                  {t('preview')}
                </Button>
                <Modal
                  show={showLetter}
                  onHide={() => setShowLetter(false)}
                  size='xl'
                  backdrop='static'
                  keyboard={false}
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('preview')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <ViewLetter data={LetterData} type='sip' />
                  </Modal.Body>
                </Modal>
              </>
            )}
          </div>

          <div className='table-responsive mt-5 bdr'>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-2 text-center'>{t('kontrak-item')}</th>
                  <th className='td-order-2 text-center'>Status</th>
                  <th className='td-order-3 text-center'>{t('kontrak-aksi')}</th>
                  <th className='td-order-4 text-center'>Sales Org</th>
                  <th className='td-order-2 text-center'>{t('kontrak-incoterm')}</th>
                  <th className='td-order-4 text-center'>{t('kontrak-wilayah')}</th>
                  {sektorID == '1' ? (
                    <th className='td-order-2 text-center'>{t('segment')}</th>
                  ) : (
                    ''
                  )}
                  <th className='td-order-3 text-center'>{t('End Customer')}</th>
                  {sektorID != '2' ? '' : <th className='td-order-2 text-center'>{t('Sektor')}</th>}
                  <th className='td-order-2 text-center'>{t('kontrak-jenis')}</th>
                  <th className='td-order-2 text-center'>{t('Product Code')}</th>
                  <th className='td-order-4 text-center'>{t('kontrak-nama')}</th>
                  <th className='td-order-3 text-center'>{t('kontrak-spek')}</th>
                  {retailFlag == 'AR03' ? (
                    <>
                      <th className='td-order-2 text-center'>{t('Submission Quantum')}</th>
                      {sektorID != '2' ? (
                        <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                      ) : (
                        ''
                      )}
                      <th className='td-order-2 text-center'>{t('sub-order-hargaP')}</th>
                      {sektorID != '2' ? (
                        <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                      ) : (
                        ''
                      )}
                    </>
                  ) : (
                    <>
                      <th className='td-order-2 text-center'>{t('Submission Quantum')}</th>
                      {sektorID != '2' ? (
                        <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                      ) : (
                        ''
                      )}
                      <th className='td-order-2 text-center'>{t('sub-order-hargaP')}</th>
                      {sektorID != '2' ? (
                        <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                  {sektorID == '1' && (
                    <th className='td-order-2 text-center'>Status {t('Price')}</th>
                  )}
                  {sektorID == '2' ? (
                    <th className='td-order-2 text-center'>{t('kontrak-Gudang')}</th>
                  ) : (
                    ''
                  )}
                </tr>
              </thead>
              {addedOrder.map((data: any, _index: any) => (
                <>
                  <tbody>
                    <tr className='d-flex jusify-content-center w-100 align-items-center'>
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>{_index + 1}</span>
                      </td>
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {data['status'] === 1 ? (
                            <span className='badge badge-light-primary'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 2 ? (
                            <span className='badge badge-light-warning'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 3 ? (
                            <span className='badge badge-light-primary'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 4 ? (
                            <span className='badge badge-light-success'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 5 ? (
                            <span className='badge badge-light-success'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 6 ? (
                            <span className='badge badge-light-primary'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 7 ? (
                            <span className='badge badge-light-warning'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 8 ? (
                            <span className='badge badge-light-primary'>
                              {t(data['status_text'])}
                            </span>
                          ) : data['status'] === 9 ? (
                            <span className='badge badge-light-warning'>
                              {t(data['status_text'])}
                            </span>
                          ) : (
                            <span className='badge badge-light-danger'>
                              {t(data['status_text'])}
                            </span>
                          )}
                        </span>
                      </td>
                      <td className='td-order-3 column'>
                        <div
                          className='d-flex justify-content-center align-items-center'
                          style={{margin: '1.25px 0'}}
                        >
                          <button
                            onClick={(e: any) => {
                              setDetailOrder(data)
                              // e.preventDefault()
                              // setSales(data.sales_org_code)
                              // setCity(data.city?.id)
                              // setMatNumber(data.material_number)
                              setShow1(true)
                            }}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Detail'
                          >
                            <KTSVG
                              path='/media/icons/duotune/file-text-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('order-lampiran')}
                            onClick={(e: any) => {
                              // console.log(e)
                              // e.preventDefault()
                              setShowUpload(true)
                              setFileBox(data)
                              setParam('order-item')
                              setSubOrderID(data.id)
                              ambilAttachment(data.id, 'order-item')
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/archive-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          <button
                            onClick={(e: any) => {
                              // e.preventDefault()
                              setIDSector(data.sector_id)
                              setProvinceName(data.province?.region_name)
                              setCityName(data.city?.city_name)
                              setProductName(data.product_name)
                              formattingTon(data.fixed_quantum)
                              setSubID(data.id)
                              setShow3(true)
                            }}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Jadwal')}
                          >
                            <KTSVG
                              path='/media/icons/duotune/calendar-check-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Hapus')}
                            onClick={(e: any) => {
                              // e.preventDefault()
                              removeSubOrder(_index)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/trash-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        </div>
                      </td>
                      <td className='td-order-4 text-center column'>
                        <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                      </td>
                      {data.sector?.id == 2 ? (
                        <>
                          {data.incoterm2 == null ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {data.incoterm1?.code}-{data.incoterm2_id}
                              </span>
                            </td>
                          ) : (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {data.incoterm1?.code}-{data.incoterm2?.code}
                              </span>
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          {data.incoterm2 == null ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {data.incoterm1?.code}
                                {data.incoterm2_id == null || data.incoterm2_id == '0'
                                  ? ''
                                  : '-' + data.incoterm2_id}
                              </span>
                            </td>
                          ) : (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {data.incoterm1?.code}-{data.incoterm2?.code}
                              </span>
                            </td>
                          )}
                        </>
                      )}

                      <td className='td-order-4 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={
                              data.province?.region_name ||
                              '' + (data.city?.city_name ? ', ' + data.city?.city_name : '')
                            }
                            index={_index}
                            className='spec-sliceee'
                          />
                        </span>
                      </td>

                      {sektorID == '1' ? (
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>{t(data.segment_name)}</span>
                        </td>
                      ) : (
                        ''
                      )}
                      <td className='td-order-3 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={
                              data?.end_user_multiple
                                ? handleShowValue(data.end_user)
                                : data.end_user
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </span>
                      </td>
                      {sektorID != '2' ? (
                        ''
                      ) : (
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>{t(data.sector?.name)}</span>
                        </td>
                      )}
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>{data.product_type_desc}</span>
                      </td>
                      <td className='td-order-2 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {parseInt(data.material_number) == 0
                            ? ''
                            : data.material_number?.slice(-7)}
                        </span>
                      </td>
                      <td className='td-order-4 text-center column'>
                        <span className='d-block fs-6 py-3'>{data.product_name}</span>
                      </td>
                      <td className='td-order-3 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={data.product_spec || '-'}
                            index={_index}
                            className='spec-sliceee'
                          />
                        </span>
                      </td>
                      {retailFlag == 'AR03' ? (
                        <>
                          {data.sector_id != 2 ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? data.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>
                          ) : (
                            <></>
                          )}

                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {i18next.language === 'en'
                                ? data.fixed_quantum?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : data.fixed_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {data.sector_id === 3 ? 'MT' : 'Ton'}
                            </span>
                          </td>

                          {data.sector_id != 2 && (
                            <>
                              {data.is_formulated_price ? (
                                <>
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {t('Formulated Price')}
                                    </span>
                                  </td>
                                </>
                              ) : (
                                <>
                                  {data.sector_id == 1 ? (
                                    <>
                                      <td className='td-order-2 text-center column'>
                                        <span className='d-block fs-6 py-3'>
                                          {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                            i18next.language ===
                                          'en'
                                            ? data.request_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.request_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                        </span>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td className='td-order-2 text-center column'>
                                        <span className='d-block fs-6 py-3'>
                                          USD {PriceFormater(data.request_price)} /MT
                                        </span>
                                      </td>
                                    </>
                                  )}
                                </>
                              )}

                              {data.sector_id != 3 ? (
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>
                                    {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                      (i18next.language === 'en'
                                        ? data.fixed_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : data.fixed_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })) +
                                      (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                  </span>
                                </td>
                              ) : (
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>
                                    USD {PriceFormater(data.fixed_price)} /MT
                                  </span>
                                </td>
                              )}
                            </>
                          )}

                          {data.sector_id != 3 ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {(data.sector_id !== 3 ? 'Rp' : 'USD') + i18next.language === 'en'
                                  ? data.fixed_price?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.fixed_price?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                              </span>
                            </td>
                          ) : (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                USD {PriceFormater(data.fixed_price)} /MT
                              </span>
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          {data.sector_id != 2 ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? data.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>
                          ) : (
                            <></>
                          )}

                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {i18next.language === 'en'
                                ? data.fixed_quantum?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : data.fixed_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {data.sector_id === 3 ? 'MT' : 'Ton'}
                            </span>
                          </td>

                          {data.sector_id != 2 && (
                            <>
                              {data.is_formulated_price ? (
                                <>
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {t('Formulated Price')}
                                    </span>
                                  </td>
                                </>
                              ) : (
                                <>
                                  {data.sector_id == 1 ? (
                                    <>
                                      <td className='td-order-2 text-center column'>
                                        <span className='d-block fs-6 py-3'>
                                          {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                            i18next.language ===
                                          'en'
                                            ? data.request_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.request_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                        </span>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      {data.sector_id == 1 ? (
                                        <>
                                          <td className='td-order-2 text-center column'>
                                            <span className='d-block fs-6 py-3'>
                                              {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                                (i18next.language === 'en'
                                                  ? data.request_price?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : data.request_price?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                            </span>
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          <td className='td-order-2 text-center column'>
                                            <span className='d-block fs-6 py-3'>
                                              USD {PriceFormater(data.request_price)} /MT
                                            </span>
                                          </td>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}

                              {data.sector_id != 3 ? (
                                <td className='td-order-2 text-center column'>
                                    { data?.price_usd != "0" ? <>
                                      <span className='d-block fs-6 py-3'>USD {PriceFormater(data.price_usd)} /MT</span>
                                    </> : <>
                                      <span className='d-block fs-6 py-3'>
                                        {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                          (i18next.language === 'en'
                                            ? data.fixed_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : data.fixed_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })) +
                                          '/Ton'}
                                      </span>
                                    </> }
                                </td>
                              ) : (
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>
                                    USD {PriceFormater(data.fixed_price)} /MT
                                  </span>
                                </td>
                              )}
                            </>
                          )}

                          {data.sector_id != 3 ? (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                  (i18next.language === 'en'
                                    ? data.fixed_price?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : data.fixed_price?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })) +
                                  (data.sector_id !== 3 ? '/Ton' : '/MT')}
                              </span>
                            </td>
                          ) : (
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                USD {PriceFormater(data.fixed_price)} /MT
                              </span>
                            </td>
                          )}
                        </>
                      )}
                      {data.sector_id == 1 && (
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {data.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                          </span>
                        </td>
                      )}
                      {data.sector_id == 2 ? (
                        <td className='td-order-2 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            <PopoverText
                              content={data.plant_desc || '-'}
                              index={_index}
                              placement='bottom'
                              className='spec-sliceee'
                            />
                          </span>
                        </td>
                      ) : (
                        ''
                      )}
                    </tr>
                  </tbody>
                </>
              ))}
            </table>
            {/* End Table Head */}
          </div>

          {addedOrder.length >= 1 ? (
            <>
              <Row className='mt-5'>
                <Col md={10}>
                  <Row className='mb-3'>
                    <Col md={3}>
                      <p className='fs-4 mt-2'>{t('Total Kuantum')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={
                          (i18next.language === 'en'
                            ? totalQuantum?.toLocaleString('en', {maximumFractionDigits: 4})
                            : totalQuantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })) +
                          ' ' +
                          'Ton'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={2}></Col>
              </Row>
              {/* <Row className=''>
                      <Col md={6}>
                        <Row className='mb-3'>
                          <Col md={4}>
                            <p className='fs-4 mt-2'>Total {t('kontrak-harga')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? totalPrice?.toLocaleString('en', { maximumFractionDigits: 4 })
                                  : totalPrice?.toLocaleString('id', { maximumFractionDigits: 4 })
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}></Col>
                    </Row> */}
              <Row className=''>
                <Col md={10}>
                  <Row className='mb-3'>
                    <Col md={3}>
                      <p className='fs-4 mt-2'>{t('Grand Total')}</p>
                    </Col>
                    <Col md={8}>
                      {sektorID != '3' ? (
                        grandtotalUsd ? <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'USD ' + (i18next.language === 'en'
                              ? grandtotalUsd.toLocaleString('en', {maximumFractionDigits: 4})
                              : grandtotalUsd.toLocaleString('id', {maximumFractionDigits: 4}))
                          }
                          disabled
                        /> : <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'Rp ' + (i18next.language === 'en'
                              ? grandtotal.toLocaleString('en', {maximumFractionDigits: 4})
                              : grandtotal.toLocaleString('id', {maximumFractionDigits: 4}))
                          }
                          disabled
                        />
                      ) : (
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={'USD ' + PriceFormater(grandtotal)}
                          disabled
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={2}></Col>
              </Row>
            </>
          ) : (
            <></>
          )}

          <hr/>

          <SettingApproval
            items={addedOrder}
            reviewers={reviewers}
            approvers={approvers}
            onChangeReviewers={onChangeReviewers}
            onChangeApprovers={onChangeApprovers}
          />

          <hr/>

          <div className='d-flex justify-content-end mt-5'>
            {/* {approvalState == true && (
                <Button variant='danger' className='me-2' type='submit'>
                  Revisi
                </Button>
              )} */}

            <Button
              className='me-2'
              variant='secondary'
              onClick={() => navigate('/management/si/all')}
            >
              {t('sip-batal')}
            </Button>

            {/* {approvalState == true && (
                <>
                  <Button variant='danger' className='me-2' type='submit'>
                    {t('order-tolak')}
                  </Button>
                  <Button variant='primary' className='me-2' type='submit'>
                    Approve
                  </Button>
                </>
              )} */}
            <Button
              variant='primary'
              className='ml-2'
              onClick={() => setShowApprove(true)}
              disabled={btnLoading}
            >
              {t('buat')}
            </Button>
          </div>
          <Modal
            show={show2}
            onHide={() => {
              setShow2(false)
              setIndexOrder([])
            }}
            backdrop='static'
            keyboard={false}
            centered
            scrollable
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('pilih')} Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isLoadingModal ? (
                <Skeleton width={100} height={30} />
              ) : (
                <>
                  <Accordion>
                    {orderSelect.map((data: any, _index: any) => (
                      <>
                        {/* <label>{indexOrder.indexOf(_index)} {indexOrder[_index]}</label> */}
                        {selectedIndex.indexOf(_index) == -1 && (
                          <>
                            <Accordion.Item eventKey={data?.id}>
                              <Accordion.Header>
                                {data?.id} / {data?.produsen?.name} / {data?.product_name} /{' '}
                                {data?.incoterm1?.code}
                                {data?.incoterm2 == null
                                  ? data?.incoterm2_id == null || data?.incoterm2_id == '0'
                                    ? ''
                                    : ' - ' + data?.incoterm2_id
                                  : ' - ' + data?.incoterm2?.code}{' '}
                                /{' '}
                                {data?.provice
                                  ? data.province?.region_name +
                                    ' - ' +
                                    data?.city?.city_name +
                                    ' /'
                                  : ''}{' '}
                                {(i18next.language === 'en'
                                  ? data.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) + (data.sector_id === 3 ? ' MT' : ' Ton')}
                                {sektorID == '1' &&
                                  (data.include_ppn ? ' / Include PPN' : ' / Exclude PPN')}
                              </Accordion.Header>
                              <Accordion.Body style={{backgroundColor: 'white'}}>
                                {sektorID == '2' && (
                                  <Row>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + _index}
                                            value={_index}
                                            disabled={!data.have_action}
                                            onClick={() => onclickCheckBox(_index)}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-Gudang')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.plant_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kuantum')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data.sector?.id == 2 ? (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code + ' - ' + data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm2_id == null ||
                                                    data.incoterm2_id == '0'
                                                      ? data.incoterm1?.code
                                                      : data.incoterm1?.code +
                                                        '-' +
                                                        data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data.product_spec} />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-hargaP')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? data.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {sektorID == '1' && (
                                  <Row>
                                    {
                                      !UserSegment(data.segment_code) && (
                                        <Col md={12} className='mb-4'>
                                            <div className="alert alert-warning">{t('not-match-segment')}</div>
                                        </Col>
                                      )
                                    }
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {
                                            UserSegment(data.segment_code) ? <>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                value={_index}
                                                disabled={!data.have_action}
                                                onClick={() => onclickCheckBox(_index)}
                                              />
                                            </> : <>
                                            <span data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('not-match-segment')}>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                disabled
                                              />
                                            </span>
                                            </>
                                          }
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('Kuantum Pengajuan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-kuantumD')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                                : data.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' Ton'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              data?.shipping_tolerance > 1
                                                ? data?.shipping_tolerance + '%'
                                                : ''
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_note}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('segment')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={t(data.segment_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.end_user}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 '>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data.sector?.id == 2 ? (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code + ' - ' + data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm2_id == null ||
                                                    data.incoterm2_id == '0'
                                                      ? data.incoterm1?.code
                                                      : data.incoterm1?.code +
                                                        '-' +
                                                        data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-hargaP')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? data.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      { data?.price_usd != "0" ? <Row className='mb-3'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-hargaD')}/Ton USD</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            aria-label='Default select example'
                                            size='sm'
                                            value={
                                              'USD ' + (i18next.language === 'en'
                                                ? data.price_usd?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data.price_usd?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }))
                                            }
                                            disabled
                                          />
                                        </Col>
                                      </Row> : <Row className='mb-3'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6 '>{t('sub-order-hargaD')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            aria-label='Default select example'
                                            size='sm'
                                            value={
                                              'Rp ' + (i18next.language === 'en'
                                                ? data.fixed_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : data.fixed_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }))
                                            }
                                            disabled
                                          />
                                        </Col>
                                      </Row> }

                                      <Row className='my-7'>
                                        <Col sm={6} className='d-flex '>
                                          <Row sm={8} className='d-flex align-items-center'>
                                            <p className='fs-6 '>{t('termasuk-ppn')}</p>
                                          </Row>
                                          <Row
                                            sm={4}
                                            className='d-flex justify-content-start align-items-center ms-4'
                                          >
                                            <Form.Check
                                              reverse
                                              name='ppn'
                                              type='checkbox'
                                              id='ckbox-ppn'
                                              checked={data.include_ppn}
                                            />
                                          </Row>
                                        </Col>
                                        <Col sm={6} className='d-flex'>
                                          <Row sm={8} className='d-flex align-items-center'>
                                            <p className='fs-6 '>{t('Formulated Price')}</p>
                                          </Row>
                                          <Row
                                            sm={4}
                                            className='d-flex justify-content-start align-items-center ms-4'
                                          >
                                            <Form.Check
                                              reverse
                                              name='formulated_price'
                                              type='checkbox'
                                              id='formulated_price'
                                              checked={data.is_formulated_price}
                                            />
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data.product_spec} />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={data.notes}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {sektorID == '3' && (
                                  <Row>
                                    {
                                      !UserSegment(data.segment_code) && (
                                        <Col md={12} className='mb-4'>
                                            <div className="alert alert-warning">{t('not-match-segment')}</div>
                                        </Col>
                                      )
                                    }
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={8}>
                                        {
                                            UserSegment(data.segment_code) ? <>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                value={_index}
                                                disabled={!data.have_action}
                                                onClick={() => onclickCheckBox(_index)}
                                              />
                                            </> : <>
                                            <span data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('not-match-segment')}>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                disabled
                                              />
                                            </span>
                                            </>
                                          }
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-item')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control value={data.id} disabled size='sm' />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.produsen?.name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-wilayah')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_type_desc}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data.request_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                                : data.request_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? data.fixed_quantum?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                                : data.fixed_quantum?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  }) + ' MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              data?.shipping_tolerance > 1
                                                ? data?.shipping_tolerance + '%'
                                                : ''
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('kontrak-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec data={data?.product_spec} />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_note}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.end_user}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6}>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>Status</p>
                                        </Col>
                                        <Col md={8}>
                                          <span className='d-block '>
                                            <span className='badge badge-light-primary'>
                                              {t(data.status_text)}
                                            </span>
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('Sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.sector?.name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-incoterm')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {data.sector?.id == 2 ? (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code + ' - ' + data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    data.incoterm2_id == null ||
                                                    data.incoterm2_id == '0'
                                                      ? data.incoterm1?.code
                                                      : data.incoterm1?.code +
                                                        '-' +
                                                        data.incoterm2_id
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={
                                                    data.incoterm1?.code +
                                                    ' - ' +
                                                    data.incoterm2?.code
                                                  }
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(data.city?.city_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('kontrak-nama')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data.product_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-hargaP')}/MT</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'USD' + PriceFormater(data.request_price) + '/MT'
                                            }
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-3'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            aria-label='Default select example'
                                            size='sm'
                                            value={'USD' + PriceFormater(data.fixed_price) + '/MT'}
                                            disabled
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='my-7'>
                                        <Col sm={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('Formulated Price')}</p>
                                        </Col>
                                        <Col
                                          sm={8}
                                          className='d-flex justify-content-start align-items-center'
                                        >
                                          <Form.Check
                                            reverse
                                            name='formula_Price'
                                            type='checkbox'
                                            value={data.is_formulated_price}
                                            disabled
                                            id='formula_Price'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={data?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>

                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={data.notes}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          </>
                        )}
                      </>
                    ))}
                  </Accordion>
                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      className='justify-content-end me-1'
                      onClick={() => addInOrder('all')}
                      hidden={orderSelect.length < 2 ? true : false}
                    >
                      {t('selectall')}
                    </Button>
                    <Button
                      className='justify-content-end'
                      hidden={orderSelect.length < 1 ? true : false}
                      onClick={() => addInOrder('satuan')}
                    >
                      {t('Save')}
                    </Button>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={show3}
            onHide={() => setShow3(false)}
            centered
            size='xl'
            backdrop='static'
            keyboard={false}
            scrollable
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                {productName} | {fixedQuantum} Ton
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                {t('Jadwal')}
              </span>
              <AddRemoveJadwal id={subID} is_amendment={'false'} />
            </Modal.Body>
          </Modal>

          <Modal
            show={showDetail}
            onHide={() => setShowDetail(false)}
            centered
            scrollable
            backdrop='static'
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('Detail Sub Order')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>Sales Org</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control
                      value={detailOrder.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('End Customer')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control
                      value={
                        detailOrder?.end_user_multiple
                          ? handleShowValue(detailOrder.end_user)
                          : detailOrder.end_user
                        // detailOrder.end_user_detail?.name
                        //   ? detailOrder.end_user_detail?.name
                        //   : detailOrder.end_user
                      }
                      as='textarea'
                      disabled
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-sektor')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={t(detailOrder.sector?.name)} type='text' disabled />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-incoterm1')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={detailOrder.incoterm1?.code} type='text' disabled />
                  </td>
                </tr>
              </table>
              {detailOrder.sector?.id == 2 ? (
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '135px'}}>
                      <h6>{t('sub-order-incoterm2')}</h6>
                    </td>
                    <td className='w-50'>
                      <Form.Control
                        value={
                          detailOrder.incoterm2?.code
                            ? detailOrder.incoterm2?.code
                            : detailOrder.incoterm2_id
                        }
                        type='text'
                        disabled
                      />
                    </td>
                  </tr>
                </table>
              ) : (
                <table
                  className='mb-3'
                  hidden={
                    detailOrder.incoterm2_id == '0' || detailOrder.incoterm2_id == null
                      ? true
                      : false
                  }
                >
                  <tr>
                    <td style={{width: '135px'}}>
                      <h6>{t('sub-order-incoterm2')}</h6>
                    </td>
                    <td className='w-50'>
                      {detailOrder.incoterm2?.code == null ? (
                        <Form.Control
                          value={
                            detailOrder.incoterm2_id == '0' || detailOrder.incoterm2_id == null
                              ? ''
                              : detailOrder.incoterm2_id
                          }
                          type='text'
                          disabled
                        />
                      ) : (
                        <Form.Control
                          value={detailOrder.incoterm2?.code ? detailOrder.incoterm2?.code : ''}
                          type='text'
                          disabled
                        />
                      )}
                    </td>
                  </tr>
                </table>
              )}

              {sektorID == '3' ? (
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '135px'}}>
                      <h6>{t('sub-order-negara')}</h6>
                    </td>
                    <td className='w-50'>
                      <Form.Control type='text' value={detailOrder.country_desc} disabled />
                    </td>
                  </tr>
                </table>
              ) : (
                <>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-provinsi')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          type='text'
                          value={detailOrder.province?.region_name}
                          disabled
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-kota')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control type='text' value={detailOrder.city?.city_name} disabled />
                      </td>
                    </tr>
                  </table>
                </>
              )}
              {detailOrder.sector?.id == 2 ? (
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '135px'}}>
                      <h6>{t('sub-order-gudang')}</h6>
                    </td>
                    <td className='w-50'>
                      <Form.Control value={detailOrder.plant_desc} type='text' disabled />
                    </td>
                  </tr>
                </table>
              ) : (
                ''
              )}

              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-jenis')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={detailOrder.product_type_desc} type='text' disabled />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-produk')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={detailOrder.product_name} type='text' disabled />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-spek')}</h6>
                  </td>
                  <td className='w-50'>
                    <FieldProductSpec data={detailOrder.product_spec} />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-hargaP')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control
                      value={
                        i18next.language === 'en'
                          ? parseFloat(detailOrder.fixed_price).toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : parseFloat(detailOrder.fixed_price).toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })
                      }
                      type='text'
                      disabled
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-kuantum')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control
                      value={
                        (i18next.language === 'en'
                          ? parseInt(detailOrder.fixed_quantum).toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : parseInt(detailOrder.fixed_quantum).toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })) + (detailOrder.sector_id === 3 ? ' MT' : ' Ton')
                      }
                      type='text'
                      disabled
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-catatan')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control
                      as='textarea'
                      style={{height: '40px'}}
                      value={detailOrder.notes}
                      type='text'
                      disabled
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-payment1')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={detailOrder.payment_type_1_desc} type='text' disabled />
                  </td>
                </tr>
              </table>
              <table className='mb-5'>
                <tr>
                  <td style={{width: '135px'}}>
                    <h6>{t('sub-order-payment2')}</h6>
                  </td>
                  <td className='w-50'>
                    <Form.Control value={detailOrder.payment_type_2_desc} type='text' disabled />
                  </td>
                </tr>
              </table>
            </Modal.Body>
          </Modal>

          <Modal
            size='lg'
            show={showUpload}
            onHide={() => {
              setShowUpload(false)
              setIsPrivate(false)
              setTempRole([])
              setFileBox({})
            }}
            backdrop='static'
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {fileBox?.product_name
                  ? (fileBox.province ? fileBox.province?.region_name : '') +
                    (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                    (fileBox.province ? ' | ' : '') +
                    fileBox.product_name +
                    (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                  : t('File Box')}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isLoadingModal ? (
                <Skeleton width={100} height={30} />
              ) : (
                <>
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={(_: string) => {}}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                              value={description}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate1'
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                              }}
                              id='isPrivate1'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={isPrivate.toString()}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button
                          variant='primary'
                          className='w-100'
                          onClick={() => handleUpload()}
                          disabled={btnLoading}
                        >
                          {btnLoading ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            t('order-kirim')
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div className='table-responsive mt-4 bdr'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {allFiles.length == 0 && <tr>
                        <td colSpan={6}>
                        <div className="text-center p-4">No Attachment</div>
                        </td>
                      </tr>}
                      {allFiles.map((data: any, _index: number) => (
                        <tbody key={data?.id ?? _index}>
                          <tr className=''>
                            <td className='text-center'>
                              <label>{_index + 1}</label>
                            </td>
                            <td className='text-center'>
                              <label>{data.description}</label>
                            </td>
                            <td className='text-center'>
                              <label>{dateformat(data.updated_at)}</label>
                            </td>
                            {/* <td className='text-center'>
                              <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                            </td> */}
                            <td className='text-center'>
                              {data.user?.customer_code == null ? (
                                <label>{data.user?.name}</label>
                              ) : (
                                <label>{data.user?.customer?.name}</label>
                              )}
                            </td>
                            <td className='text-center'>
                              {data.private ? (
                                data.roles.length > 0 ? (
                                  <PopoverText
                                    content={handleShowRoleName(data.roles)}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                ) : (
                                  'Private'
                                )
                              ) : (
                                'Public'
                              )}
                            </td>
                            <td className='text-center'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() => handleDownloadAttachment(data.file_path) }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                              {(hakAkses?.attachment_delete ||
                                CheckSameIDAttachment(data.user_role_flag)) && (
                                <button
                                  onClick={() => deleteAttachment(data.id)}
                                  className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            size='lg'
            show={showUpload2}
            onHide={() => {
              setShowUpload2(false)
              setIsPrivate(false)
              setTempRole([])
            }}
            backdrop='static'
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('order-fileBox')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isLoadingModal ? (
                <Skeleton width={100} height={30} />
              ) : (
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          <InputFile
                              setFileName={setNamaFile}
                              setFiles={setFiles2}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            id='uploadketerangan'
                            placeholder={t('order-keterangan')}
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate2'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate2'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      <Button
                        variant='primary'
                        className='w-100'
                        onClick={() => handleUploadHeader()}
                      >
                        {t('order-kirim')}
                      </Button>
                    </div>
                  </Col>
                  <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {attachment
                        .slice(0)
                        .reverse()
                        .map((data: any, _index: number) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(getCurrentFormattedDate())}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>{localStorage.getItem('username')}</label>
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleNameFromState(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() => handleDownloadBase64(data.file_r)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() =>
                                    handleDeleteUploadHeader(
                                      attachment.length - 1 - _index,
                                      attachment,
                                      setAttachment
                                    )
                                  }
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </table>
                  </div>
                </Row>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={show1}
            onHide={handleClose1}
            backdrop='static'
            keyboard={false}
            centered
            scrollable
            size='xl'
          >
            <Modal.Header closeButton>
              <Modal.Title>Detail SIP</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {detailOrder?.sector?.id == 1 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.id}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={detailOrder?.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.incoterm1?.code}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.province?.region_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.product_type_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            i18next.language === 'en'
                              ? detailOrder?.request_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                              : detailOrder?.request_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            i18next.language === 'en'
                              ? detailOrder?.fixed_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                              : detailOrder?.fixed_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.payment_type_1_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <FieldProductSpec data={detailOrder?.product_spec} />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('segment')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          type='text'
                          value={t(detailOrder.segment_name)}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          as='textarea'
                          size='sm'
                          style={{height: '40px'}}
                          value={
                            detailOrder?.end_user_multiple
                              ? handleShowValue(detailOrder.end_user)
                              : detailOrder.end_user
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={t(detailOrder?.sector?.name)}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {detailOrder?.incoterm2 == null ? (
                          <Form.Control
                            size='sm'
                            aria-label='Default select example'
                            value={
                              detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                ? ''
                                : detailOrder?.incoterm2_id
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.city?.city_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.product_name}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'Rp' + i18next.language === 'en'
                              ? detailOrder?.request_price?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailOrder?.request_price?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                      </Col>
                      <Col md={8}>
                      { detailOrder.price_usd != "0" ? <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'USD ' + (i18next.language === 'en'
                              ? detailOrder?.price_usd?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailOrder?.price_usd?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))
                          }
                          disabled
                        /> : 
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'Rp ' + (i18next.language === 'en'
                              ? detailOrder?.fixed_price?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailOrder?.fixed_price?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))
                          }
                          disabled
                        />
                      }
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.payment_type_2_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='my-7'>
                      <Col sm={6} className='d-flex '>
                        <Row sm={8} className='d-flex align-items-center'>
                          <p className='fs-6'>{t('termasuk-ppn')}</p>
                        </Row>
                        <Row
                          sm={4}
                          className='d-flex justify-content-start align-items-center ms-4'
                        >
                          <Form.Check
                            reverse
                            name='ppn'
                            disabled
                            type='checkbox'
                            id='ckbox-ppn'
                            checked={detailOrder?.include_ppn}
                          />
                        </Row>
                      </Col>
                      <Col sm={6} className='d-flex'>
                        <Row sm={8} className='d-flex align-items-center'>
                          <p className=' fs-6'>{t('Formulated Price')}</p>
                        </Row>
                        <Row
                          sm={4}
                          className='d-flex justify-content-start align-items-center ms-4'
                        >
                          <Form.Check
                            reverse
                            name='formula_Price'
                            type='checkbox'
                            disabled
                            checked={detailOrder?.is_formulated_price}
                            id='formula_Price'
                          />
                        </Row>
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          as='textarea'
                          style={{height: '40px'}}
                          value={detailOrder?.notes}
                          disabled
                        />
                      </Col>
                    </Row>
                    {/* <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                  </Col>
                                  <Col md={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-3 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={detailOrder?.include_ppn}
                                  />
                                  </Col>
                                </Row> */}
                  </Col>
                </Row>
              )}

              {detailOrder?.sector?.id == 2 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.id}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={detailOrder?.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.incoterm1?.code}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.province?.region_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.plant_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          as='textarea'
                          style={{height: '40px'}}
                          value={detailOrder?.product_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            i18next.language === 'en'
                              ? detailOrder?.request_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                              : detailOrder?.request_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' Ton'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.payment_type_1_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          as='textarea'
                          size='sm'
                          style={{height: '40px'}}
                          value={
                            detailOrder?.end_user_multiple
                              ? handleShowValue(detailOrder.end_user)
                              : detailOrder.end_user
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={t(detailOrder?.sector?.name)}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {detailOrder?.incoterm2 == null ? (
                          <Form.Control
                            size='sm'
                            aria-label='Default select example'
                            value={
                              detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                ? ''
                                : detailOrder?.incoterm2_id
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.city?.city_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.product_type_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <FieldProductSpec data={detailOrder?.product_spec} />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-hargaP')}/Ton</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            'Rp' + i18next.language === 'en'
                              ? detailOrder?.request_price?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailOrder?.request_price?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          as='textarea'
                          style={{height: '40px'}}
                          value={detailOrder?.notes}
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {detailOrder?.sector?.id == 3 && (
                <Row>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.id}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          value={detailOrder?.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.incoterm1?.code}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.province?.region_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.product_type_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            i18next.language === 'en'
                              ? detailOrder?.request_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                              : detailOrder?.request_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={
                            i18next.language === 'en'
                              ? detailOrder?.fixed_quantum?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                              : detailOrder?.fixed_quantum?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }) + ' MT'
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.payment_type_1_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col md={8}>
                        <FieldProductSpec data={detailOrder?.product_spec} />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          as='textarea'
                          style={{height: '40px'}}
                          value={detailOrder?.notes}
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='6'>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('End Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          as='textarea'
                          size='sm'
                          style={{height: '40px'}}
                          value={
                            detailOrder?.end_user_multiple
                              ? handleShowValue(detailOrder.end_user)
                              : detailOrder.end_user
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={t(detailOrder?.sector?.name)}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col md={8}>
                        {detailOrder?.incoterm2 == null ? (
                          <Form.Control
                            size='sm'
                            aria-label='Default select example'
                            value={
                              detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                ? ''
                                : detailOrder?.incoterm2_id
                            }
                            disabled
                          />
                        ) : (
                          <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.city?.city_name}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.product_name}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-hargaP')}/MT</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={'USD' + PriceFormater(detailOrder?.request_price) + '/MT'}
                          disabled
                        />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col md={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={'USD' + PriceFormater(detailOrder?.fixed_price) + '/MT'}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          size='sm'
                          value={detailOrder?.payment_type_2_desc}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='my-7'>
                      <Col sm={4} className='d-flex align-items-center'>
                        <p className=' fs-6'>{t('Formulated Price')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start align-items-center'>
                        <Form.Check
                          reverse
                          name='formula_Price'
                          type='checkbox'
                          checked={detailOrder?.is_formulated_price}
                          id='formula_Price'
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Modal.Body>
          </Modal>

          <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h3 className='text-center mb-5'>{t('apakahAndaYakin create SIP')}</h3>
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-secondary' onClick={() => setShowApprove(false)}>
                {t('Tidak')}
              </Button>
              <Button className='btn btn-primary' onClick={submitSIP} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  )
}

export {SICreate}
